import { Button, message, Modal } from 'antd'
import RequestFundsForm from '../../../../components/Sales/Invoices/RequestFunds/RequestFundsForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import useModalData from '../../../../elements/Hooks/useModalData'
import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'
import InvoicesApi from '../../../../api/Sales/Invoices'

const api = new InvoicesApi()

function RequestFundsCont(props) {
  const { visible, submitting, formRef, onShow, onCancel, setSubmitting, checkForm } = useModalData()

  const [remiLines, setRemiLines] = useState([])
  const currency = get(remiLines, '[0]voucher.currency', get(remiLines, '[0]receipt.currency', null))
  const isAllSameCurrency = remiLines.every((i) => get(i, 'voucher.currency', get(i, 'receipt.currency')) === currency)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      const data = await api.requestFunds({
        ...newObject,
        invoiceType: 'Funds Request',
        lines: remiLines,
      })

      props.history.push({
        pathname: `/clients/invoices/${data._key}/view`,
      })

      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <div>
      <Button size={'small'} onClick={onShow}>
        Request Funds
      </Button>
      <Modal
        title="Request Funds"
        // visible={true}
        visible={visible}
        onCancel={onCancel}
        destroyOnClose={true}
        footer={
          <FooterButtons
            visible={true}
            isNew={true}
            disableSubmit={!isAllSameCurrency}
            submit={submit}
            submitting={submitting}
          />
        }
        width={'80%'}>
        <RequestFundsForm ref={formRef} {...{ submitting, remiLines, setRemiLines }} />
      </Modal>
    </div>
  )
}

export default withRouter(RequestFundsCont)
